const handler = require('./handler');
const printer = require('./printer');

module.exports = { handleComments: handler, printComment: printer };
